var map = {
	"./4-_Wattathon.mp3": 132,
	"./458627__tetrisrocker__clock.mp3": 133,
	"./Backrooms.mp3": 134,
	"./Finish.mp3": 135,
	"./dead.mp3": 136,
	"./dear_god.mp3": 137,
	"./get_it_because_pipe_organ.mp3": 138,
	"./good_luck_w_your_ears_honestly.mp3": 139,
	"./i_think_its_finished_priska_turbo_time.mp3": 140,
	"./justifiedRecursion.mp3": 141,
	"./no_gods_no_master.mp3": 142,
	"./riku_completed_i_think_idefk_anymore.mp3": 143,
	"./scratch1.mp3": 144,
	"./scratch10.mp3": 145,
	"./scratch11.mp3": 146,
	"./scratch12.mp3": 147,
	"./scratch13.mp3": 148,
	"./scratch2.mp3": 149,
	"./scratch3.mp3": 150,
	"./scratch4.mp3": 151,
	"./scratch5.mp3": 152,
	"./scratch6.mp3": 153,
	"./scratch7.mp3": 154,
	"./scratch8.mp3": 155,
	"./scratch9.mp3": 156,
	"./turntablist.mp3": 157,
	"./watt_3_but_jr_owns_it.mp3": 158,
	"./youbrokeit.mp3": 61
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73;